/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ConnectAzureBackupAccountRequest {
  /**
  * The tenant ID. This field is required. 
  */
  'tenantId': string;
  /**
  * The subscription ID. This field is required. 
  */
  'subscriptionId': string;
  /**
  * The location of the backup account. This field is required. e.g. \"eastus\" 
  */
  'location'?: string;
  /**
  * The ADX cluster ID. This field is required. 
  */
  'adxClusterId'?: string;
  /**
  * The ADX database name. This field is required. 
  */
  'adxClusterUri'?: string;
  /**
  * The ADX identity. This field is required. 
  */
  'adxIdentity'?: string;
  /**
  * The federated managed identity resource ID associated with the data access  application registration. This managed identity is granted necessary permissions  in the customer tenant for backup operations. 
  */
  'federatedManagedIdentityResourceId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenantId",
      "baseName": "tenantId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "subscriptionId",
      "baseName": "subscriptionId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    },
    {
      "name": "adxClusterId",
      "baseName": "adxClusterId",
      "type": "string",
      "format": ""
    },
    {
      "name": "adxClusterUri",
      "baseName": "adxClusterUri",
      "type": "string",
      "format": ""
    },
    {
      "name": "adxIdentity",
      "baseName": "adxIdentity",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "federatedManagedIdentityResourceId",
      "baseName": "federatedManagedIdentityResourceId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectAzureBackupAccountRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

